import {
  FeedstockBmpPotentialNutrient,
  FeedstockBmpPotentialNutritionPropName
} from '../../../../../models/project/feedstock/feedstock-bmp-potential/feedstock-bmp-potential-type-models/feedstock-bmp-potential-nutrient.model';
import { ValidationInterface } from '../../../validation.interface';
import { ProjectValidationUnit } from '../../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../../unit-value.validation';

export class FeedstockBmpPotentialNutritionValidation implements ValidationInterface {
  /** The current BMP potential nutrition obj that is being validated */
  bmpPotentialNutrition: FeedstockBmpPotentialNutrient;

  /**
   * Sets the BMP potential nutrition obj that will be used for validation
   * @param bmpPotentialNutrition will be used to set the current BMP potential nutrition obj
   */
  constructor(bmpPotentialNutrition: FeedstockBmpPotentialNutrient) {
    if (!bmpPotentialNutrition) throw Error('invalid BMP potential nutrition provided for validation');
    this.bmpPotentialNutrition = new FeedstockBmpPotentialNutrient(bmpPotentialNutrition);
  }

  /**
   * Get a validation unit containing the validation data for the current BMP potential nutrition obj
   * @param validationUnit, if provided will have the validation for the current BMP potential nutrition
   * added to it. If it is not provided a new validation unit will be returned.
   */
  getValidation(validationUnit = new ProjectValidationUnit()): ProjectValidationUnit {
    if (!this.bmpPotentialNutrition) throw Error('unable to validation BMP potential');
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialNutrition.carbohydrate).getValidation(),
      FeedstockBmpPotentialNutritionPropName.carbohydrate
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialNutrition.lipidFat).getValidation(),
      FeedstockBmpPotentialNutritionPropName.lipidFat
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialNutrition.protein).getValidation(),
      FeedstockBmpPotentialNutritionPropName.protein
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialNutrition.biodegradability).getValidation(),
      FeedstockBmpPotentialNutritionPropName.biodegradability
    );
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current BMP potential nutrition obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}
